'use strict';
module.exports = require('./html-tags.json');



//////////////////
// WEBPACK FOOTER
// ./~/html-tags/index.js
// module id = 181
// module chunks = 35783957827783 162898551421021